export const prependProtocol = (domain: string): string => {
  if (domain.startsWith('https://')) return domain.toLowerCase()
  return `https://${domain.toLowerCase()}/`
}
